import { DimensionsGridView } from '~/components/attributes/dimensions';
import { PageContainer } from '~/components/page-container';

export function Dimensions() {
	return (
		<PageContainer>
			<DimensionsGridView />
		</PageContainer>
	);
}
